import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { OutOfStockItem, OutOfStockProblem } from '@models';

/**
 * RCP-458 — the products of a structured out-of-stock error, or `null` when the error is anything
 * else. `httpErrorInterceptor` passes a `409` through untouched, so the body is still on `error`.
 */
export const outOfStockItemsFrom = (error: unknown): OutOfStockItem[] | null => {
  if (!(error instanceof HttpErrorResponse) || error.status !== HttpStatusCode.Conflict) return null;

  const items = (error.error as Partial<OutOfStockProblem> | null)?.items;
  return Array.isArray(items) && items.length ? items : null;
};
